(function () {
  var BYOB_PATH = '/apps/box-builder/build-your-own-bundle';

  if (!window.location.pathname.includes(BYOB_PATH)) {
    return;
  }

  var params = new URLSearchParams(window.location.search);
  var bundleSize = Number(params.get('bundle_size'));

  var allowedBundleSizes = [6, 8, 10, 12];

  if (!allowedBundleSizes.includes(bundleSize)) {
    return;
  }

  var cardsWrapperSelector = '[class*="SizeDiscountSelector-module__cards__"]';
  var cardSelector = '[class*="SizeDiscountSelector-module__card__"]';
  var runKey = 'byob-auto-select:' + window.location.pathname + ':' + window.location.search;
  var runTtl = 15000;
  var storedRunAt = getStoredRunAt();

  if (storedRunAt && Date.now() - storedRunAt < runTtl) {
    return;
  }

  var observer = null;
  var hasSelected = false;

  function cleanText(element) {
    return (element && element.textContent ? element.textContent : '').replace(/\s+/g, ' ').trim();
  }

  function isVisible(element) {
    if (!element) {
      return false;
    }

    var rect = element.getBoundingClientRect();
    var styles = window.getComputedStyle(element);

    return rect.width > 0 && rect.height > 0 && styles.display !== 'none' && styles.visibility !== 'hidden';
  }

  function isDisabled(element) {
    return Boolean(
      element.disabled ||
        element.getAttribute('disabled') !== null ||
        element.getAttribute('aria-disabled') === 'true'
    );
  }

  function getStoredRunAt() {
    try {
      return Number(sessionStorage.getItem(runKey) || 0);
    } catch (error) {
      return 0;
    }
  }

  function setStoredRunAt() {
    try {
      sessionStorage.setItem(runKey, String(Date.now()));
    } catch (error) {
      return;
    }
  }

  function findPackCard() {
    var label = bundleSize + ' Pack';
    var images = Array.from(document.querySelectorAll(cardsWrapperSelector + ' img[alt]'));
    var image = images.find(function (img) {
      return img.alt.trim().toLowerCase() === label.toLowerCase();
    });

    if (image) {
      return image.closest(cardSelector);
    }

    return Array.from(document.querySelectorAll(cardsWrapperSelector + ' ' + cardSelector)).find(function (card) {
      return new RegExp('\\b' + bundleSize + '\\s*Pack\\b', 'i').test(cleanText(card));
    });
  }

  function dispatchMouseEvent(element, type) {
    element.dispatchEvent(
      new MouseEvent(type, {
        bubbles: true,
        cancelable: true,
        view: window,
      })
    );
  }

  function clickElement(element) {
    try {
      dispatchMouseEvent(element, 'mouseover');
      dispatchMouseEvent(element, 'mousedown');
      dispatchMouseEvent(element, 'mouseup');
      dispatchMouseEvent(element, 'click');
    } catch (error) {
      element.click();
    }
  }

  function findNextButton() {
    return Array.from(document.querySelectorAll('button, a, [role="button"]')).find(function (button) {
      var text = cleanText(button).toLowerCase();

      return isVisible(button) && !isDisabled(button) && (text === 'next' || text.includes('next'));
    });
  }

  function clickNextFallback() {
    window.setTimeout(function () {
      if (new URLSearchParams(window.location.search).get('step') !== '0') {
        return;
      }

      if (!document.querySelector(cardsWrapperSelector)) {
        return;
      }

      var nextButton = findNextButton();

      if (nextButton) {
        clickElement(nextButton);
      }
    }, 600);
  }

  function stopObserver() {
    if (observer) {
      observer.disconnect();
      observer = null;
    }
  }

  function trySelectPack() {
    if (hasSelected) {
      return true;
    }

    var card = findPackCard();

    if (!card) {
      return false;
    }

    hasSelected = true;
    setStoredRunAt();

    clickElement(card);
    clickNextFallback();
    stopObserver();

    return true;
  }

  if (trySelectPack()) {
    return;
  }

  observer = new MutationObserver(function () {
    trySelectPack();
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
  });

  window.setTimeout(stopObserver, runTtl);
})();
